import { Link } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import { displayManageSearchPath } from '../../displays/manage/displayManageRoutes';
import type { ScreenUploadIntent } from './useScreenUploadIntent';

type ScreenUploadBannerProps = {
  intent: ScreenUploadIntent;
};

/** Tells the operator where their Library upload is going and how far along it is. */
export function ScreenUploadBanner({ intent }: ScreenUploadBannerProps) {
  const { t } = useTranslation(['content', 'common']);
  const screen = intent.screenName ?? t('forScreen.thisScreen');
  const strong = <span className="font-bold" />;

  return (
    <div
      className="flex flex-wrap items-center gap-3 rounded-[14px] border px-4 py-3 text-sm"
      style={{
        borderColor: 'var(--gs-accent)',
        background: 'color-mix(in srgb, var(--gs-accent) 8%, var(--gs-panel))',
        color: 'var(--gs-ink)',
      }}
    >
      {intent.phase === 'error' ? (
        <span className="min-w-0 flex-1 font-medium" style={{ color: 'var(--gs-bad)' }} role="alert">
          {intent.error}
        </span>
      ) : (
        <span className="min-w-0 flex-1" role="status">
          <Trans
            t={t}
            i18nKey={`forScreen.${intent.phase}`}
            values={{ screen }}
            components={{ strong }}
          />
        </span>
      )}

      {intent.phase === 'error' ? (
        <Link
          to={displayManageSearchPath(intent.screenId)}
          className="shrink-0 rounded-[10px] border border-line px-3.5 py-2 text-sm font-semibold text-ink hover:border-[var(--gs-accent)]"
        >
          {t('forScreen.backToScreen')}
        </Link>
      ) : null}

      <button
        type="button"
        disabled={intent.phase === 'playing'}
        onClick={intent.cancel}
        className="shrink-0 rounded-[10px] border border-line px-3.5 py-2 text-sm font-semibold text-ink hover:border-[var(--gs-accent)] disabled:opacity-50"
      >
        {t('common:actions.cancel')}
      </button>
    </div>
  );
}
